import React from 'react'

function skill() {
    return (
        <section id="skill">
            <div className="col-md-12">
                <div className="col-md-12">
                    <h1 className="section-title">
                        <span className="text-white">Skills</span>
                    </h1>
                </div>
                <div className="col-md-12 text-center">
                    <ul className="list-inline ms-auto skill-icon">
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-html5">
                                    <p style={{fontSize:"25%"}}className="text-center">Html 5</p></i> 
                                </div>
                            </span>
                        </li><li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-react"><p style={{fontSize:"25%"}}className="text-center">React</p></i> 
                                </div>
                            </span>
                        </li><li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-js"><p style={{fontSize:"25%"}}className="text-center">Javascript</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-php"><p style={{fontSize:"25%"}}className="text-center">PHP</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-github"><p style={{fontSize:"25%"}}className="text-center">Git</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-wordpress"><p style={{fontSize:"25%"}}className="text-center">Wordpress</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i class="fab fa-bootstrap"><p style={{fontSize:"25%"}}className="text-center">Bootstrap</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fab fa-css3-alt"><p style={{fontSize:"25%"}}className="text-center">CSS</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i className="fas fa-database"><p style={{fontSize:"25%"}}className="text-center">Database</p></i>
                                </div>
                            </span>
                        </li>
                        <li className="list-inline-item mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                <i class="fas fa-photo-video"><p style={{fontSize:"25%"}}className="text-center">Multimedia</p></i>
                                </div>
                            </span>
                        </li>

                               
                               
                            
                        
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default skill

